const thousandSeparator = {
  methods: {
    addThousandSeparator(amount: number): string {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}

export default thousandSeparator
